import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cached = null;
let inflight = null;

export function useRole() {
  const [user, setUser] = useState(cached);
  useEffect(() => {
    if (cached) return;
    inflight = inflight || api.get("/auth/me").then((r) => { cached = r.data; return r.data; }).catch(() => null);
    inflight.then((u) => setUser(u));
  }, []);
  const role = user?.role;
  return {
    user,
    role,
    canReview: ["scientific_reviewer", "senior_reviewer", "admin"].includes(role),
    canApprove: ["scientific_reviewer", "senior_reviewer", "admin"].includes(role),
    canLock: ["senior_reviewer", "admin"].includes(role),
    isAdmin: role === "admin",
  };
}
